import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useWalletDisbursementTransactions from "../../custom-hooks/useWalletDisbursementTransactions";
import { formatMoney } from "../../helpers/formatter";
import Loader from "../../NewComponents/Loader/Loader.component";
import NoTableDataAvailable from "../../NewComponents/NoTableDataAvailable/NoTableDataAvailable.component";
import CustomSelectDropdown from "../CustomHTMLElements/CustomSelectDropdown";
import Paginator from "../Pagination/Pagination.component";
import useAllAggregators from "../../custom-hooks/useAllAggregators";
import { appInsights } from "../../config/appInsights";

// Wallet disbursement transactions added to admin

const WalletDisbursementTransactions = () => {
  const [preState, setPreState] = useState({
    pageNumber: 1,
    size: 20,
  });
  const [state, setState] = useState({
    pageNumber: 1,
    size: 20,
    startDate: "",
    endDate: "",
    searchStatus: "",
  });
  const [count, setCount] = useState(null);
  const { data, status, error } = useWalletDisbursementTransactions(state);

  const { data: aggregatorData } = useAllAggregators();
  if (data) {
    if (count === null) {
      setCount(data?.totalCount);
    }
  }

  useEffect(() => {
    appInsights.trackPageView({
      name: "Aggregator Wallet Transactions - (WalletDisbursementTransactions.jsx)",
      isLoggedIn: true,
    });
  }, []);

  const handleChange = (
    e: ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const filterData = (e: FormEvent) => {
    e.preventDefault();
    setPreState({ ...state });
  };
  return (
    <div>
      {error && (
        <p className="alert alert-danger small">{JSON.stringify(error)}</p>
      )}
      {!error && (
        <div>
          <h3 className="page-title mb-3 mt-3">
            Aggregator Wallet Disbursement Transactions
          </h3>

          <div className="card">
            {status === "loading" ? (
              <div className="d-flex justify-content-center align-items-center">
                <Loader />
              </div>
            ) : (
              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center py-3">
                  <form
                    className="d-flex flex-row flex-wrap"
                    onSubmit={filterData}
                  >
                    <div className="form-group mr-5  ">
                      <div className="input-group mb-4">
                        <label className="mr-2 ">Filter By Status</label>
                        <CustomSelectDropdown
                          className="form-control"
                          value={state.searchStatus}
                          name="searchStatus"
                          onChange={handleChange}
                        >
                          <option value="">All</option>
                          <option value={0}>Pending</option>
                          <option value={1}>Approved</option>
                          <option value={2}>Declined</option>
                        </CustomSelectDropdown>
                      </div>
                    </div>

                    <div className="form-group mr-3">
                      <div className="input-group mt-2">
                        <label className="mr-2 mt-2">From </label>
                        <input
                          type="date"
                          name="startDate"
                          className="form-control"
                          value={state.startDate}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group mr-3 mt-2">
                      <div className="input-group">
                        <label className="mr-2 mt-2">To </label>
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={state.endDate}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm mt-2"
                        value="submit"
                        // disabled={status === "loading"}
                      >
                        Search
                      </button>
                    </div>
                  </form>
                </div>
                <div className="table-responsive">
                  <table className="table">
                    <thead className="bg-lighter-grey">
                      <tr>
                        <th>S/N</th>
                        <th>Aggregator Name</th>
                        <th>Recipient Name</th>
                        <th>Account Number</th>
                        <th>Bank Name</th>
                        <th>Amount</th>
                        <th>Transaction Date</th>
                        <th>Status</th>
                        {/* <th>Reference</th> */}
                        <th>Narration</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.data ? (
                        data?.data.map((item: any, _id: number) => {
                          const {
                            id,
                            aggregator_id,
                            account_name,
                            account_number,
                            bank_name,
                            amount,
                            transaction_date,
                            status,
                            maker_checker_reference,
                            narration,
                          } = item;
                          return (
                            <tr key={id}>
                              <td>
                                {(preState?.pageNumber - 1) * preState?.size +
                                  (_id + 1)}
                              </td>
                              <td>
                                {
                                  aggregatorData?.find(
                                    (agg_id: any) =>
                                      aggregator_id === agg_id.aggregator_id
                                  ).biz_name
                                }
                              </td>
                              <td>
                                {account_name ? account_name : "Not Available"}
                              </td>
                              <td>{account_number}</td>
                              <td>{bank_name}</td>
                              <td>{formatMoney(amount, "#")}</td>
                              <td>
                                {transaction_date
                                  ? transaction_date.substring(0, 10)
                                  : "N/A"}
                              </td>
                              <td>{status}</td>
                              {/* <td>{maker_checker_reference}</td> */}
                              <td>{narration}</td>
                              <td>
                                <Link
                                  to={{
                                    pathname: `/wallettransactionlog/${maker_checker_reference}`,
                                    state: {
                                      data: item,
                                    },
                                  }}
                                  className="color-blue"
                                >
                                  View Details
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <NoTableDataAvailable text="" />
                      )}
                    </tbody>
                  </table>
                </div>
                {data && data?.data && (
                  <Paginator
                    size={preState.size}
                    page={preState.pageNumber}
                    count={count}
                    changeCurrentPage={(pageNumber: number) =>
                      setPreState({ ...preState, pageNumber })
                    }
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletDisbursementTransactions;
